import Hls from "hls.js"
import { useEffect, useRef } from "react"

interface HlsVideoPlayerProps {
  src: string
  startOnLoad?: boolean
}

export const HlsVideoPlayer = ({ src, startOnLoad }: HlsVideoPlayerProps) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    if (Hls.isSupported() && videoRef.current && src) {
      const hls = new Hls()

      hls.loadSource(src)
      hls.attachMedia(videoRef.current)

      hls.on(Hls.Events.MEDIA_ATTACHED, async () => {
        if (startOnLoad) {
          await videoRef.current?.play()
        }
      })

      hls.on(Hls.Events.ERROR, (_event, data) => {
        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              console.error("Network error:", data)
              hls.startLoad()
              break
            case Hls.ErrorTypes.MEDIA_ERROR:
              console.error("Media error:", data)
              hls.recoverMediaError()
              break
            default:
              console.error("HLS error:", data)
              hls.destroy()
              break
          }
        }
      })

      return () => {
        hls.destroy()
      }
    } else if (videoRef.current) {
      // If HLS.js is not supported (like on Safari), set the source directly
      videoRef.current.src = src
    }
  }, [src, startOnLoad])

  return (
    <video ref={videoRef} controls style={{ width: "100%" }}>
      Your browser does not support the video tag.
    </video>
  )
}
